export function getCssCustomProperties(names = []) {
  if (!names?.length || typeof document === `undefined`) return {}

  const styles = getComputedStyle(document.documentElement)
  const properties = {}

  names.forEach((p) => (properties[p] = styles.getPropertyValue(p).trim()))

  return properties
}
